import Vuex from 'vuex'
import Vue from 'vue'
import api from '../lib/api'
import router from '../router'
import i18n from '../plugins/i18n'
import langs from '../data/langs'
Vue.use(Vuex)

import category from './modules/category'
import company from './modules/company'
import auth from './modules/auth'
import game from './modules/game'
import site from './modules/site'
import user from './modules/user'
import stat from './modules/stat'
import total from './modules/total'
import urls from './modules/urls'
import tournament from './modules/tournament'

export default new Vuex.Store({
  state: {
    collapsed: false,
    loading: true,
    login_loading: false
  },
  mutations: {
    TOGGLE_SIDEBAR(state) {
      state.collapsed = !state.collapsed
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_LOGIN_LOADING(state, payload) {
      state.login_loading = payload
    }
  },
  actions: {
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    async getLang({ commit }, lang_code) {
      localStorage.setItem('lang', lang_code)
      const response = await api.get(
        `https://core-v1.apiepics.com/v1/lang/get/ccpanel/${lang_code}`
      )
      const lang = response.data.langs
      i18n.setLocaleMessage(lang_code, lang)
      i18n.locale = lang_code
    },
    async checkToken({ dispatch, commit }) {
      const token = sessionStorage.getItem('token')
      if (token) {
        const response = await api.get('/me')
        const user = response.data
        dispatch('auth/setUser', { user }, { root: true })
      } else {
        dispatch('logout')
      }
    },
    checkLang({}, lang_code) {
      if (!lang_code || !langs.find(lang => lang.code === lang_code)) {
        localStorage.setItem('lang', 'en')
        return 'en'
      }
      return lang_code
    },
    async start({ dispatch, commit }) {
      await dispatch(
        'getLang',
        await dispatch('checkLang', localStorage.getItem('lang'))
      )
      await dispatch('checkToken')
      // other checks and gets here
      commit('SET_LOADING', false)
    },
    async login({ commit, dispatch }, payload) {
      commit('SET_LOGIN_LOADING', true)
      try {
        const response = await api.post('/sessions', payload)
        const { token } = response.data
        sessionStorage.setItem('token', token)
        dispatch('auth/getUser')
      } catch (error) {
        console.error(error)
      }
      commit('SET_LOGIN_LOADING', false)
    },
    logout({ commit }) {
      try {
        sessionStorage.removeItem('token')
        if (router.currentRoute.path !== '/login') router.push('/login')
        commit('SET_LOADING', false, { root: true })
      } catch (error) {
        console.error(error)
        commit('SET_LOADING', false, { root: true })
      }
    }
  },
  modules: {
    company,
    category,
    auth,
    game,
    site,
    user,
    stat,
    total,
    urls,
    tournament
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js